/* Service for the bankingDetails, currently only for NZ 12-05-17 */

var BankingService = (function() {
    var bankingDetails = {};

    var getBankingDetails = function(paymentData, countryCode) {
        if (paymentData !== null) {
            bankingDetails = {
                accountHolder: paymentData.accountName,
                accountNumber: paymentData.bankAccNum,
                routingNumber: '',
                acceptedDirectDepositPolicy: true,
                country: countryCode,
                IBAN: null,
                branchNumber: paymentData.trannum,
                bankName: paymentData.bankName,
                accountType: 'N'
            };
        }
        return bankingDetails;
    };

    return {
        'getBankingDetails': getBankingDetails
    };
})();

export default BankingService;



//////////////////
// WEBPACK FOOTER
// ./services/banking-service.js
// module id = 374
// module chunks = 0